import React, { useState, useContext } from 'react'
import { redirect, useNavigate } from 'react-router-dom'
import API from '../../../services/API'
import { UserContext } from '../../../App'

//@MUI
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import SendShoutoutDialog from '../../shoutouts/SendShoutoutDialog'

// The avatar visual (name + photo) on its own, shared so it can be rendered
// without the dropdown menu. Pass onClick to make the avatar clickable
// (AvatarMenu does); omit it for an inert display-only avatar (the demo
// header shows the current persona this way, next to the switch button).
export const UserAvatarVisual = ({ user, onClick }) => (
  <Box display="flex" columnGap={1} alignItems="center">
    <Typography color="text.primary" display={{ xs: 'none', lg: 'inherit' }}>
      {user?.firstName} {user?.lastName}
    </Typography>
    <Avatar
      src={user?.photograph}
      sx={{ width: 24, height: 24, ...(onClick && { cursor: 'pointer' }) }}
      onClick={onClick}
    />
  </Box>
)

const AvatarMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [shoutoutOpen, setShoutoutOpen] = useState(false)
  const handleClick = (e) => setAnchorEl(e.currentTarget)
  const open = !!anchorEl
  const navigate = useNavigate()

  const { user, setUser } = useContext(UserContext)

  const handleLogout = () => {
    API.delete('/logout')
      .then((res) => {
        setUser({})
        window.location.reload()
      })
      .catch((e) => console.log(e))
  }

  return (
    <Box display="flex" columnGap={1}>
      <UserAvatarVisual user={user} onClick={handleClick} />
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            navigate('/my-tasks')
            setAnchorEl(null)
          }}
        >
          My Tasks
        </MenuItem>
        <MenuItem
          onClick={() => {
            navigate('/my-audits')
            setAnchorEl(null)
          }}
        >
          My Audits
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
            navigate('/my-account')
          }}
        >
          My Account
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
            setShoutoutOpen(true)
          }}
        >
          Send a Shoutout
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
            navigate('/privacy-policy')
          }}
        >
          Privacy Policy
        </MenuItem>
        <MenuItem onClick={handleLogout}>Log Out</MenuItem>
      </Menu>
      <SendShoutoutDialog open={shoutoutOpen} onClose={() => setShoutoutOpen(false)} />
    </Box>
  )
}

export default AvatarMenu
